module.exports = __webpack_public_path__ + "img/170.a27b963f.jpg";